
import React from 'react';

const PublicationList = ({ publications }) => {
    return (

        <div style={{ display: 'grid', gap: '1.5rem' }}>
            {publications.map((pub, index) => (
                <article key={index} style={{
                    borderBottom: '1px solid var(--color-border)',
                    paddingBottom: '1.5rem',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    gap: '0.5rem'
                }}>
                    <div style={{ flex: '1 1 300px' }}>
                        <h3 style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                            {pub.link ? (
                                <a href={pub.link} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    {pub.title}
                                </a>
                            ) : (
                                pub.title
                            )}
                        </h3>
                        <p style={{ margin: 0, fontSize: '0.85rem' }}>{pub.journal}</p>
                    </div>
                    <div style={{ textAlign: 'right', minWidth: '40px' }}>
                        <span style={{ color: 'var(--color-text-secondary)', fontSize: '0.85rem' }}>{pub.year}</span>
                    </div>
                </article>
            ))}
        </div>
    );
};

export default PublicationList;
